import '@/assets/vendor/fontawesome/css/all.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import '@/assets/sass/style.scss'

window.$ = window.jQuery = require('jquery')
import 'bootstrap'
import 'bootstrap-select'
import '@/assets/vendor/fontawesome/js/all.js'
